import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SuccessIcon, ErrorIcon } from '../constants.tsx';
import { trackTikTokEvent } from '../tiktok.ts';

const PaymentResult: React.FC = () => {
    const { t } = useTranslation();
    const [status, setStatus] = useState<string | null>(null);

    useEffect(() => {
        let statusParam = new URLSearchParams(window.location.search).get('status');
        if (!statusParam) {
            const hash = window.location.hash;
            if (hash.includes('?')) {
                const queryString = hash.split('?')[1];
                const urlParams = new URLSearchParams(queryString);
                statusParam = urlParams.get('status');
            }
        }
        setStatus(statusParam);

        if (statusParam === 'success') {
            trackTikTokEvent('CompletePayment', {
                currency: 'SAR',
                content_name: 'Subscription Payment'
            });
        }
    }, []);

    const isSuccess = status === 'success';

    return (
        <section className="relative z-10 pt-32 pb-20 lg:pt-40 lg:pb-28">
            <div className="max-w-3xl mx-auto px-4 sm:px-8 xl:px-0 text-center">
                <div className="flex justify-center mb-8">
                    {isSuccess ? <SuccessIcon /> : <ErrorIcon />}
                </div>

                <h1 className="text-4xl font-bold text-white mb-6">
                    {t(isSuccess ? 'paymentSuccessTitle' : 'paymentFailedTitle')}
                </h1>

                <p className="text-xl text-white/80 mb-10">
                    {t(isSuccess ? 'paymentSuccessMessage' : 'paymentFailedMessage')}
                </p>

                <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                    {isSuccess ? (
                        <a
                            href="https://t.me/TAD_VIP_bot"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="button-bg-gradient inline-flex rounded-lg text-white font-medium py-3 px-8 shadow-lg hover:shadow-none ease-in duration-300"
                        >
                            {t('paymentSuccessButton')}
                        </a>
                    ) : (
                        <>
                            <a
                                href="#home"
                                className="button-border-gradient relative rounded-lg text-white font-medium py-3 px-8 shadow-lg hover:shadow-none ease-in duration-300"
                            >
                                {t('paymentFailedRetryButton')}
                            </a>
                            <a
                                href="https://t.me/Tad_cs_BOT"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="button-bg-gradient inline-flex rounded-lg text-white font-medium py-3 px-8 shadow-lg hover:shadow-none ease-in duration-300"
                            >
                                {t('paymentFailedSupportButton')}
                            </a>
                        </>
                    )}
                </div>
            </div>
        </section>
    );
};

export default PaymentResult;
